import { styled } from '@mui/material';

export const Container = styled('section')`
  margin: 0;
  padding: 0;

  & + section {
    margin-top: 1rem;
  }
`;

export const ContentListCard = styled('ul')`
  padding: 0;
  margin: 0;
`;
